export const StatisticProp = Object.freeze({
    Position: 'position',
    LabelText: 'labelText',
    ValueColor: 'valueColor',
    ValueText: 'valueText',
    ValueIsSmall: 'valueIsSmall',
    ValueIconName: 'valueIconName',
});
